<script setup>
  import { useAuthStore } from '@stores/auth';
  import { useTransition } from '@vueuse/core';
  import BaseSpinner from '@components/base/Spinner.vue';
  import useNavbar from '@composables/base/useNavbar';
  import { useWithdraw } from "@composables/user/useWithdraw";

  const { state } = useWithdraw();

  const minimumAmount =  number_format(state.settings.withdraw_min / 100, ',', '.');
  const authStore = useAuthStore();

  // Transições para saldo e bônus
  const transitionConfig = {
    duration: 1500,
    transition: [0.75, 0, 0.25, 1]
  };

  const amountBalance = useTransition(authStore.balanceAmount, transitionConfig);
  const realBalance = useTransition(authStore.balance.value, transitionConfig);
  const bonusBalance = useTransition(() => authStore.balance.bonus / 100, transitionConfig);

  const isLoadingBalance = computed(
    () => realBalance.value === null || realBalance.value === undefined
  );

  const { depositStore } = useNavbar();
</script>

<template>
  <div
    class="flex flex-col gap-2 mb-4 w-full bg-brand-primary/40 border border-brand-primary rounded-md p-3"
  >
    <h6 class="font-bold">Saldo</h6>
    <div class="flex items-center justify-between">
      <div>
        <h1 class="text-4xl font-semibold">
          <BaseSpinner v-if="isLoadingBalance" size="xs" />
          <template v-else>{{ money(realBalance) }}</template>
        </h1>
        <p class="font-bold text-sm">Saldo bônus {{ money(bonusBalance) }}</p>
      </div>
      <div class="flex items-center justify-center h-20 w-20 my-2 rounded-full bg-brand-primary/15">
        <Icon name="healthicons:money-bag" size="50" class="text-brand-primary" />
      </div>
    </div>
    <div class="flex items-center gap-2 select-none">
      <BaseButton
        size="xs"
        variant="primary"
        class="h-10 w-full !text-sm"
        @click="depositStore.toggleModal()"
      >
        Depositar
      </BaseButton>
      <BaseButton
        size="xs"
        to="/user/wallet/withdraw"
        :disabled="realBalance < minimumAmount"
        variant="secondary"
        class="h-10 w-full !text-sm text-white disabled:pointer-events-none"
      >
        Sacar
      </BaseButton>
    </div>
  </div>
</template>
